module.exports = __webpack_public_path__ + "img/sad-smiley-blue.f33aad3a.svg";